import { render, staticRenderFns } from "./ListFrame.vue?vue&type=template&id=865584f4&scoped=true"
import script from "./ListFrame.vue?vue&type=script&lang=js"
export * from "./ListFrame.vue?vue&type=script&lang=js"
import style0 from "./ListFrame.vue?vue&type=style&index=0&id=865584f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865584f4",
  null
  
)

export default component.exports